import { memo } from 'react';
import TradeInput from 'src/components/Inputs/TradeInput';
import Input from 'src/components/primitives/Input/Input';
import RadioGroup from 'src/components/primitives/RadioGroup/RadioGroup';
import DefinitionTooltip from 'src/components/Tooltip/DefinitionTooltip/DefinitionTooltip';
import useScaledOrderCountInput from 'src/components/TradeForm/ScaledOrderCountInput/hooks/useScaledOrderCountInput';

const NUMBER_FORMAT_PROPS = {
	// Max number is currently 32, so can limit integer digits to 2.
	maximumIntegerDigits: 2,
};

function ScaledOrderCountInput() {
	const {
		currentValue,
		newBrandPresetOptions,
		customInputValue,
		currentValueSource,
		handleBlur,
		handleFocus,
		handleCustomInputChange,
		handlePresetClick,
		isMobileScreenSize,
	} = useScaledOrderCountInput();

	if (isMobileScreenSize) {
		return (
			<TradeInput
				id="order-count"
				label="Order Count"
				onChange={handleCustomInputChange}
				value={customInputValue}
				onBlur={handleBlur}
				onFocus={handleFocus}
				numberFormatProps={NUMBER_FORMAT_PROPS}
			/>
		);
	}

	return (
		<div className="flex w-full flex-col gap-y-sm">
			<DefinitionTooltip
				key="order-count"
				definitionId="tradingOrderCount"
				className="w-fit typo-b4 text-text-secondary"
			>
				Order Count
			</DefinitionTooltip>
			<div className="flex gap-x-xs">
				<div className="basis-1/3">
					<Input
						labelVariant="none"
						type="number"
						placeholder="Custom"
						onChange={handleCustomInputChange}
						value={customInputValue}
						onBlur={handleBlur}
						onFocus={handleFocus}
						numberFormatProps={NUMBER_FORMAT_PROPS}
					/>
				</div>
				<RadioGroup.Default
					size="sm"
					variant="card"
					className="grow gap-x-xs"
					items={newBrandPresetOptions}
					value={
						currentValueSource === 'preset'
							? currentValue.toString()
							: undefined
					}
					onValueChange={(value) => handlePresetClick(Number(value))}
				/>
			</div>
		</div>
	);
}

export default memo(ScaledOrderCountInput);
